import { ScheduleGridBodyCellProps } from 'components/ScheduleGrid/ScheduleGrid.Types';
import ProductionScheduleRightBodyCellCellEntity from './ProductionSchedule.RightBodyCell.CellEntity';
import { injectStores } from "@intrasync/react";
import { ServiceStore, RootStore } from '@intrasync/stores';

interface EntityProps {
  id: number;
  controlNumber: string;
  markNumber: string;
  castingDate: string;
  jobNumber: number;
}

interface ProductionScheduleRightBodyCellProps
  extends ScheduleGridBodyCellProps {
  itemsFromEntity: unknown[];
  panelStore: ServiceStore;
  rootStore?: RootStore;
}

const ProductionScheduleRightBodyCell = injectStores(
  (props: ProductionScheduleRightBodyCellProps) => {
    // const panelStore = props.panelStore as ServiceStore;
    // console.log('ProductionScheduleRightBodyCell props', props);
    const backgroundColor = props.rowIndex % 2 === 0 ? '#f0f0f0' : '#e0e0e0';
    if (props.itemsFromEntity?.length === 0) {
      return (
        <div
          style={{
            ...props.style,
            // ...props.styles,
            borderLeft: '1px solid #eee',
            borderRight: '1px solid #eee',
            borderTop: '1px solid #eee',
            borderBottom: '2px solid black',
            backgroundColor: backgroundColor,
            height: ((props?.style?.height as number) || 50) - 3,
          }}
        />
      );
    }
    const { itemsFromEntity } = props;
    return (
      <div
        style={{
          ...props.style,
          borderLeft: '1px solid #eee',
          borderRight: '1px solid #eee',
          borderTop: '1px solid #eee',
          borderBottom: '2px solid black',
          backgroundColor: backgroundColor,
          height: ((props?.style?.height as number) || 50) - 3,
          // ...props.styles,
          display: 'flex',
          flexDirection: 'column',
          // alignItems: 'flex-start',
          alignContent: 'flex-start',
        }}
      >
        {itemsFromEntity
          .sort((a, b) =>
            (a as EntityProps).controlNumber.localeCompare(
              (b as EntityProps).controlNumber
            )
          )
          .map((currentEntity) => {
            return (
              <ProductionScheduleRightBodyCellCellEntity
                key={(currentEntity as EntityProps).id}
                entity={currentEntity as EntityProps}
                {...props}
              />
            );
          })}
      </div>
    );
  }
);

export default ProductionScheduleRightBodyCell;
